@custom-media --mobile (max-width: 768px);

.container {
  @media (--mobile) {
    margin-top: 1em;
  }
}

.number {
  display: inline-block;
  vertical-align: top;
  width: 2rem;
}

.text {
  display: inline-block;
  width: calc(100% - 3em);

  p {
    margin-bottom: 0;
  }
}

.required::after {
  content: '*';
  margin-left: 0.25em;
}

.warningText {
  color: var(--fudisRed);
  font-size: 0.8em;
  margin-left: 2.5em;
  line-height: 3em;
  margin-bottom: 0;
}
